import * as React from 'react';
import { MergeCodeModal } from 'app/area/codetable/common/merge-code/merge-code-modal';
import { MergeCodeContainerProps } from 'app/area/codetable/common/merge-code/types';
import styles from './merge-code-container.scss';

export const MergeCodeContainer = (props: MergeCodeContainerProps) => {

  const { codetableId, breadcrumbs, translation, validation, codeAccessConfiguration: { canDelete },
    codeListBranch, mergeCode, metadata, codetableOptions,
    reloadCodeItems: reloadCodeItems, deleteCodeItem, loadCodetableOptions,
    updateMergeCode, resetValidation
  } = props;

  const fetching = codeListBranch
    .map(item => item?.items)
    .flat()
    .find(item => item?.id === mergeCode?.codeId)?.deletingCodeItem;

  const handleDeleteCodeItem = (uncheckSelectItem: boolean) => {
    const { mergeCode: { codeId, reassignReferencesToCode: { value = undefined } = {} } = {} } = props;
    const successAction = () => {
      reloadCodeItems();
      onClose();
    };

    deleteCodeItem({
      codetableId, 
      codeId, 
      successMessage: translation.code_item_successfully_deleted,
      successAction,
      ...(!uncheckSelectItem && { reassignReferencesToCode: value }),
      violationErrorMessage: translation.merge_code_violation_error
    });
  };

  const onClose = () => updateMergeCode({ ...mergeCode, showMergeCode: false });

  return mergeCode?.showMergeCode
    && <MergeCodeModal
      className={styles.container}
      mergeCode={mergeCode}
      breadcrumbs={breadcrumbs}
      metadata={metadata}
      options={codetableOptions}
      canDelete={canDelete}
      fetching={fetching}
      translation={translation}
      validation={validation}
      deleteCodeItem={handleDeleteCodeItem}
      onClose={onClose}
      updateMergeCode={updateMergeCode}
      loadOptions={loadCodetableOptions}
      resetValidation={resetValidation} />;
};
